<app-header-component [headerData] = "currentHeaderData" (closeModal)="closeModal()"></app-header-component>

<ion-content>
  <ion-list class="room-set ion-list-transparent-bg-color"
    *ngFor="let item of guestRoomsInfo; index as index">
    <ion-item lines="full" class="ion-item-transparent-bg-color"> 
      <ion-label class="ion-label-primary-text-color fs-3 font600">{{"hotel.room_seletion_modal.room" | translate}} {{ index + 1 }}</ion-label>
      <ion-button *ngIf="index !== 0 && index === guestRoomsInfo.length - 1"
        (click)="removeRoom()" fill="clear">
        <ion-icon slot="icon-only" class="primary-icon-color" name="close-outline"></ion-icon>
      </ion-button>
    </ion-item>
    <ion-item lines="none" class="ion-item-transparent-bg-color">
      <ion-label class="ion-label-primary-text-color fs-4 font600">{{"hotel.room_seletion_modal.adults" | translate}}</ion-label>
      <div class="ion-no-padding padt6 padb6 ion-float-end">
        <counter-buttons
          (addFunction) = "addAdult(index)"
          (removeFunction) = "removeAdult(index)"
          [item] = "index"
          [quantity] = "item.adults"
          [containerStyle]="{'min-width': '110px', 'height': '35px', 'border-radius':'6px'}"
        ></counter-buttons>
      </div>
    </ion-item>
    <ion-item lines="none" class="ion-item-transparent-bg-color">
      <ion-label class="ion-label-primary-text-color fs-4 font600">{{"hotel.room_seletion_modal.children" | translate}}</ion-label>
      <div class="ion-no-padding padt6 padb6 ion-float-end">
        <counter-buttons
          (addFunction) = "addChild(index)"
          (removeFunction) = "removeChild(index)"
          [item] = "index"
          [quantity] = "item.children"
          [containerStyle]="{'min-width': '110px', 'height': '35px', 'border-radius':'6px'}"
        ></counter-buttons>
      </div>
    </ion-item>
    <ion-item lines="none" class="ion-item-transparent-bg-color"
      *ngFor="let childAge of item.childrenAges; index as ageIndex">
      <ion-label class="ion-padding-start ion-label-primary-text-color fs-3 font600">
        {{"hotel.room_seletion_modal.children_age" | translate}} {{ ageIndex + 1 }}
      </ion-label>
      <ion-select placeholder="{{'hotel.room_seletion_modal.age' | translate}}" name="{{ 'child-' + ageIndex }}"
        (ionChange)="addChildAge($event, index, ageIndex)"
        value="{{ childAge }}" interface="popover" class="text-color"
        required>
        <ion-select-option value="1">1 {{"hotel.room_seletion_modal.year" | translate}}
        </ion-select-option>
        <ion-select-option value="2">2 {{"hotel.room_seletion_modal.years" | translate}}
        </ion-select-option>
        <ion-select-option value="3">3 {{"hotel.room_seletion_modal.years" | translate}}
        </ion-select-option>
        <ion-select-option value="4">4 {{"hotel.room_seletion_modal.years" | translate}}
        </ion-select-option>
        <ion-select-option value="5">5 {{"hotel.room_seletion_modal.years" | translate}}
        </ion-select-option>
        <ion-select-option value="6">6 {{"hotel.room_seletion_modal.years" | translate}}
        </ion-select-option>
        <ion-select-option value="7">7 {{"hotel.room_seletion_modal.years" | translate}}
        </ion-select-option>
        <ion-select-option value="8">8 {{"hotel.room_seletion_modal.years" | translate}}
        </ion-select-option>
        <ion-select-option value="9">9 {{"hotel.room_seletion_modal.years" | translate}}
        </ion-select-option>
        <ion-select-option value="10">10 {{"hotel.room_seletion_modal.years" | translate}}
        </ion-select-option>
        <ion-select-option value="11">11 {{"hotel.room_seletion_modal.years" | translate}}
        </ion-select-option>
        <ion-select-option value="12">12 {{"hotel.room_seletion_modal.years" | translate}}
        </ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>

  <ion-button class="ion-float-end fs-3 font500 clear-btn mar10 btn-pad-start10"
    (click)="addRoom()">
    <ion-icon slot="start" class="primary-icon-color" name="add-outline"></ion-icon>
    {{"hotel.room_seletion_modal.add_room" | translate}}
  </ion-button>
</ion-content>
<ion-footer>
  <ion-toolbar class="ion-padding">
    <ion-button (click)="submitChanges()" expand="block" mode="ios" class="fs-4 font500 primary-btn">
      {{"hotel.room_seletion_modal.done" | translate}}
    </ion-button>
  </ion-toolbar>
</ion-footer>